import {authServicePost, spotheroGet} from 'api';
import {OperatorUserResponse} from './auth.types';

/**
 * Gets the currently authenticated user
 *
 * @see '/api/v1/operator-user/'
 */
export const getUser = async () => {
    const response = await spotheroGet<OperatorUserResponse>(
        'operator-user/',
        null,
        {
            withCredentials: true,
        }
    );

    return response.data;
};

/**
 * Sets the AUTH_TOKEN cookie for the currently authenticated user
 *
 * @see '/auth/set-cookie/'
 */
export const setAuthCookie = async () => {
    await authServicePost('/auth/set-cookie/', null);
};
